import { useTranslation } from "react-i18next";

import { formatAppVersion } from "../appVersion";
import { APP_VERSION } from "../branding";
import { CLIENT_BUILD } from "../clientBuild";
import { isElectron } from "../env";
import { useServerConfig } from "../rpc/serverState";

export function useAppVersion() {
  useTranslation();
  const config = useServerConfig();
  return formatAppVersion({
    desktop: isElectron,
    releaseVersion: APP_VERSION,
    serverVersion: config?.environment.serverVersion ?? null,
    clientBuild: CLIENT_BUILD,
  });
}
